import React, { useState, useEffect, useMemo } from "react";
import { PiCoinsDuotone } from "react-icons/pi";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";
import ProtectedCanvasImage from "../components/ProtectedCanvasImage";

const Shortcart = () => {
  const { isAuthenticated, balance } = useAuth();

  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= FETCH WISHLIST ================= */
  const fetchWishlist = async () => {
    if (!isAuthenticated) return;

    try {
      setLoading(true);

      const res = await api.get(
        `/custwishroutes/wishlist/customer`
      );

      setWishlist(res.data.data || []);
    } catch {
      toast.error("Failed to load wishlist");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, [isAuthenticated]);

  /* ================= DELETE ITEM ================= */
  const handleRemove = async (wishlist_id) => {
    try {
      await api.delete(
        `/custwishroutes/wishlist/delete/${wishlist_id}`
      );

      setWishlist((prev) =>
        prev.filter(
          (item) =>
            item.wishlist_id !== wishlist_id
        )
      );

      toast.success("Item removed");
    } catch (error) {
      toast.error("Unable to remove item");
    }
  };

  /* ================= CALCULATIONS ================= */
  const totalProducts = wishlist.length;

  const totalCoin = useMemo(
    () =>
      wishlist.reduce(
        (acc, item) =>
          acc +
          (item.product?.credit_cost || 0),
        0
      ),
    [wishlist]
  );

  const remainingCoin =
    balance - totalCoin;

  /* ================= UI ================= */
  return (
    <>
      <div className="py-4 border-bottom mb-4">
        <h2 className="mb-0 text-white">
          Wishlist
        </h2>

        <p
          className="mb-0 text-pink"
          style={{
            letterSpacing: "0.65px",
            fontSize: "18px",
          }}
        >
          Total Products :{" "}
          <b>{totalProducts}</b>
          &nbsp; | &nbsp; Total Coin :{" "}
          <b>{totalCoin}</b>
          &nbsp; | &nbsp; Your Balance :{" "}
          <b>{balance}</b>
        </p>
      </div>

      <div className="wishlistcardscroll">
        <ul>
          {wishlist.map((item) => {
            const product =
              item.product;

            const thumbnailUrl =
              product?.thumbnail
                ?.image_url ||
              "/placeholder.png";

            return (
              <li key={item.wishlist_id}>
                <div className="d-flex align-items-start gap-3 pCArd">
                  <div
                    className="pimage"
                    style={{
                      overflow: "hidden",
                    }}
                  >
                    <ProtectedCanvasImage
                      src={thumbnailUrl}
                      alt={
                        product?.product_name ||
                        "Product"
                      }
                      width="100%"
                      height="100%"
                      objectFit="cover"
                      objectPosition="top center"
                    />
                  </div>

                  <div>
                    <h6 className="pe-5">
                      {product?.product_name}
                    </h6>

                    <small
                      style={{
                        color: "#c7c7c7",
                        letterSpacing:
                          "0.65px",
                      }}
                    >
                      Basic PNG
                    </small>

                    <p className="text-pink d-block">
                      <PiCoinsDuotone />{" "}
                      {product?.credit_cost ??
                        "Free"}
                    </p>

                    <Button
                      icon="pi pi-times"
                      text
                      severity="danger"
                      className="p-0 text-pink"
                      tooltip="Remove"
                      tooltipOptions={{
                        position: "top",
                      }}
                      style={{
                        position:
                          "absolute",
                        top: "0px",
                        right: "0px",
                        width: "30px",
                        height: "30px",
                      }}
                      onClick={() =>
                        handleRemove(
                          item.wishlist_id
                        )
                      }
                    />
                  </div>
                </div>
              </li>
            );
          })}

          {!loading &&
            wishlist.length === 0 && (
              <li className="text-center text-muted py-3">
                Wishlist is empty
              </li>
            )}
        </ul>
      </div>
    </>
  );
};

export default Shortcart;